import { useTranslation } from "react-i18next";
import { normalizeDifficulty } from "../lib/difficulty";


/**
 * Three ascending bars instead of a coloured tag. Difficulty is ordinal, so a
 * meter carries the ranking that three unrelated tag colours do not.
 */
export default function DifficultyMeter({ value }: { value?: string | null }) {
  const { t } = useTranslation();
  const level = normalizeDifficulty(value);
  const known = level === "easy" || level === "medium" || level === "hard";
  const label = known ? t(`difficulty.${level}`) : value || t("ui.unknown");

  return (
    <span className={`diff diff--${known ? level : "unknown"}`}>
      <span className="diff__bars" aria-hidden="true">
        <i className="diff__bar" />
        <i className="diff__bar" />
        <i className="diff__bar" />
      </span>
      {label}
    </span>
  );
}
